const $ = require('jquery')

const select2 = {
  beforeMount(el, binding, vnode) {
    $(el)
      .select2()
      .on('select2:select', (e) => {
        el.dispatchEvent(new Event('change', { target: e.target }))
      })
  },
  updated(el) {
    $(el).trigger('change')
  },
}

export default select2
